module.exports = __webpack_public_path__ + "static/media/confort.62a3f6e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/confort.png
// module id = 943
// module chunks = 0